document.addEventListener("DOMContentLoaded", function () {
    var rawCisionUrl = "https://publish.ne.cision.com/papi/NewsFeed/{{key}}/Releases?startDate=&endDate=&pageIndex=0&pageSize=100&separateFirstRelease=false&detailLevel=medium";
    var announcementDetailsUrl = "https://publish.ne.cision.com/papi/Release/{{encryptedId}}/Detail";
    var localFeedUrl = "/api/news?sourceId={{source}}&language={{language}}";

    $('[data-latest-announcements]').each(function () {
        var $targetElement = $(this);
        var accessKeys = ($targetElement.data("news-feed-access-key") || "").split(",");
        var categories = ($targetElement.data("categories") || "").split(',');
        var excludedCategories = ($targetElement.data("excluded-categories") || "").split(",");
        var takeSize = parseInt($targetElement.data("take-size"));
        var localSource = $targetElement.data("local-articles-source") || 0;
        var language = $targetElement.data("language");

        categories = categories.filter(function (x) { return x.length > 0; });
        excludedCategories = excludedCategories.filter(function (x) { return x.length > 0; });

        var excludedFilter = function (release) {
            if (!release.Categories || release.Categories.length === 0) {
                return true;
            }
            return release.Categories.filter(function (category) {
                return excludedCategories.indexOf(category.Code.toLowerCase()) === -1;
            }).length > 0;
        };
        var categoriesFilter = function (release) {
            return release.Categories.filter(function (category) {
                return categories.indexOf(category.Code.toLowerCase()) !== -1 || categories.indexOf(category.Name.toLowerCase()) !== -1;
            }).length > 0;
        };

        var localRequest = null;
        if (localSource > 0) {
            localRequest = $.ajax({
                url: localFeedUrl.replace("{{source}}", localSource).replace("{{language}}", language),
                method: "GET"
            });
        }

        var getCisionRequest = function (key) {
            return $.ajax({
                url: rawCisionUrl.replace("{{key}}", key),
                method: 'GET'
            });
        };

        var allRequests = accessKeys.map(function (k) {
            if (!!k.length) {
                return getCisionRequest(k);
            }
        });
        if (localRequest !== null) {
            allRequests.push(localRequest);
        }

        var fallback = function () {
            $.ajax({
                url: rawCisionUrl.replace("{{key}}", accessKeys[0]),
                method: "GET",
                success: function (response) {
                    var filterMethod = categories.length ? categoriesFilter : excludedFilter;
                    var announcements = response.Releases.filter(filterMethod);

                    takeSize = takeSize ? takeSize : announcements.length;

                    populateTemplate($targetElement, {
                        announcements: announcements.slice(0, takeSize)
                    });
                }
            });
        };

        if (allRequests.length === 1) {
            fallback();
        } else {
            var deferreds = $.when.apply(null, allRequests);
            deferreds.done(function () {
                var items = [];
                for (var i = 0; i < arguments.length; i++) {
                    var response = arguments[i];
                    var responseData = {};
                    var singleResponse = false;
                    if (arguments.length > 1 && arguments[1] === "success") {
                        responseData = arguments[0];
                        singleResponse = true;
                    } else {
                        responseData = response[0];
                    }
                    if ($.isArray(responseData) === true) { // local feed
                        items = items.concat(responseData);
                    } else { // cision feed
                        var filterMethod = (categories.length > 0) ? categoriesFilter : excludedFilter;
                        var announcements = responseData.Releases.filter(filterMethod);

                        items = items.concat(announcements);
                    }
                    if (singleResponse === true) {
                        break;
                    }
                }

                items.sort(function (i1, i2) {
                    var d1 = Date.parse(i1.PublishDate);
                    var d2 = Date.parse(i2.PublishDate);
                    if (d1 > d2) {
                        return -1;
                    } else if (d1 < d2) {
                        return 1;
                    }
                    return 0;
                });

                takeSize = takeSize ? takeSize : items.length;

                populateTemplate($targetElement, {
                    announcements: items.slice(0, takeSize)
                });

            }).fail(function () {
                fallback();
            });
        }
    });

    $('[data-announcement-details]').each(function () {
        var $target = $(this);
        var announcementId = $target.attr("data-announcement-details");

        $.ajax({
            url: announcementDetailsUrl.replace("{{encryptedId}}", announcementId),
            method: "GET",
            success: function (response) {
                populateDetailsTemplate($target, response.Release);
                populateFiles(response.Release);
            }
        });
    });

    function populateDetailsTemplate($target, data) {
        var template = $('[data-announcement-details-template]').html();
        var renderedElement = Mustache.render(template, data);
        $('[data-current-page-breadcrumb]').html(data.Title);

        $target.html(renderedElement);
    }

    function populateTemplate($target, data) {
        data.announcements.forEach(function (announcement) {
            announcement.PublishDateFormatted = new moment(announcement.PublishDate).format("DD.MM.YYYY HH:mm");
        });

        var template = $('[data-latest-announcements-template]').html();
        var renderedElement = Mustache.render(template, data);

        $target.html(renderedElement);

        $target.find("[data-local-url]").each(function (idx, el) {
            var $el = $(el);
            if (!!$el.data("local-url")) {
                $el.attr("href", $el.data("local-url"));
            }
        });
    }
});